type BoardEmptyHintProps = {
  visible: boolean;
  canEdit: boolean;
};

/** Лёгкая подсказка на пустом холсте — без карточки и без перехвата кликов. */
export function BoardEmptyHint({ visible, canEdit }: BoardEmptyHintProps) {
  if (!visible) return null;
  return (
    <div className="wb-board-empty-hint" aria-hidden="true">
      <p className="wb-board-empty-hint__title">Пустая доска</p>
      <p className="wb-board-empty-hint__text">
        {canEdit
          ? "На панели слева: перо, фигуры, текст и виджеты — таймер, калькулятор, графики, код."
          : "Пока здесь ничего нет"}
      </p>
    </div>
  );
}
